<template>
  <div v-if="value" class="fixed top-0 left-0 right-0 bottom-0 z-50 bg-black bg-opacity-70 flex justify-center items-center p-4">
    <div class="bg-white text-center w-full max-w-[25rem] p-4 rounded-lg">
      <div class="flex justify-end w-full">
        <img
          :src="require(`@/assets/images/close.svg`)"
          alt=""
          class="w-[22px] h-[22px] cursor-pointer"
          @click="$emit('update', false)"
        />
      </div>
      <div class="text-new-gray-800 text-lg font-bold my-4">溫馨提示</div>
      <div class="text-new-gray-700 text-sm my-4">請注意! 即將前往社群網站</div>
      <button class="bg-new-primary-500 text-lg text-white font-bold w-full p-2 rounded" @click="close">確認</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseOverlay',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update'],
  model: {
    event: 'update',
  },
  methods: {
    show() {
      return new Promise((resolve) => {
        this.$emit('update', true)
        this.resolve = resolve
      })
    },
    close() {
      this.$emit('update', false)
      this.resolve(true)
    },
  },
}
</script>

<style lang="scss" scoped>
@use 'tailwindcss/base' as base;
@use 'tailwindcss/components' as components;
@use 'tailwindcss/utilities' as utilities;

:root {
  --condition: #{isFundswapTrade};
}

@if not var(--condition) {
  base components utilities * {
    box-sizing: border-box;
    border-width: 0;
    border-style: solid;
    border-color: #f5f5f5;
  }
}
</style>